import styles from "../../styles.module.scss";

const ShadowText = ({
  children,
  hidePlaceholder = false,
  shadowClassName = styles.contentShadow,
  contentClassName = styles.content,
}) => (
  <>
    {hidePlaceholder ? null : (
      <div style={{ visibility: "hidden", pointerEvents: "none", userSelect: "none" }}>
        {children}
      </div>
    )}
    <div className={shadowClassName}>{children}</div>
    <div className={contentClassName}>{children}</div>
  </>
);

export default ShadowText;
